// extracted by mini-css-extract-plugin
export default {"feed-profile":"Profile_feed-profile__p9vB6","feed-profile--img":"Profile_feed-profile--img__+7K9p","feed-profile__name":"Profile_feed-profile__name__gtYZw"};